<template>
  <div :class="$style.sectionFunctions">
    <div class="container section">
      <p class="dingbeauty-sub-title fancy-title">Functions</p>
      <h2 class="dingbeauty-title is-dotted">整合您所需要的一切功能</h2>
      <div class="function-container">
        <div class="function-item">
          <img src="@assets/dingbeauty-images/basic-plan/icon_09.svg" alt="" />
          <h3 class="title">服務＆加購設定</h3>
          <p class="sub-title">區分一般服務和加購項目，讓服務人員依據客戶當日狀況推薦現場加購，幫助服務內容更加彈性</p>
        </div>
        <div class="function-item">
          <img src="@assets/dingbeauty-images/basic-plan/icon_10.svg" alt="" />
          <h3 class="title">Line官方帳號預約</h3>
          <p class="sub-title">客戶可以輕鬆透過Line預約服務，也能輕鬆查詢包月和儲值狀態，提高預約便捷性</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" module>
.sectionFunctions {
  $color-primary: #e3c192;

  :global {
    .dingbeauty-title {
      margin-bottom: 3rem;
    }

    .function-container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 18px;
      max-width: 600px;
      margin: auto;
    }

    .function-item {
      position: relative;
      padding: 2rem 1rem;
      border: 1px solid $color-primary;
      text-align: center;

      img {
        position: absolute;
        top: 0;
        left: 50%;
        background: #fff;
        transform: translate(-50%, -60%);
        padding: 4px;
      }

      .title {
        font-size: 14px;
        margin-bottom: 1rem;
        color: $color-primary;
      }

      .sub-title {
        font-size: 12px;
        margin-bottom: 0;
        line-height: 1.7;
        color: #545662;
      }
    }
  }
}

@media (min-width: 768px) {
  .sectionFunctions {
    :global {
      .dingbeauty-title {
        margin-bottom: 5rem;
      }

      .function-container {
        grid-template-columns: 1fr 1fr;
      }

      .function-item {
        padding: 32px 24px;
        text-align: left;

        img {
          left: 1rem;
          transform: translate(0, -60%);
        }
      }
    }
  }
}
</style>
